import { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { produce } from 'immer';

// Settings Components
import { tabController } from '../../bpl-tools/utils/functions';

import Settings from './Settings';
import Style from './Style';
import { Placeholder } from '@wordpress/components';
import Timeline from './Components/Common/Timeline';
import FollowButton from './Components/Common/FollowButton';
import TweetButton from './Components/Common/TweetButton';
import usePremiumInEditor from './hooks/usePremiumInEditor';
import { twitterIcon } from './utils/icons';
import { types } from './utils/options';
import { BtnGroupPro } from '../../bpl-tools/ProControls';
import VideoPost from './Components/Common/VideoPost';
import Hastag from './Components/Common/Hastag';

const Edit = props => {
	const { className, attributes, setAttributes, clientId, isSelected } = props;
	const { type } = attributes;

	useEffect(() => { clientId && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]); // Set & Update clientId to cId

	const { isPremium } = usePremiumInEditor();
	const [aboutProOpen, setAboutProOpen] = useState(false);

	useEffect(() => tabController(), [isSelected]);

	const updateObj = (object, property, val, childProp = false) => {
		const newObj = produce(attributes[object], draft => {
			if (false !== childProp) {
				draft[property][childProp] = val;
			} else {
				draft[property] = val;
			}
		});
		setAttributes({ [object]: newObj });
	}

	const premiumProps = {
		isPremium,
		setIsProModalOpen: setAboutProOpen
	};

	return <>
		<Settings attributes={attributes} setAttributes={setAttributes} updateObj={updateObj} aboutProOpen={aboutProOpen} setAboutProOpen={setAboutProOpen} premiumProps={premiumProps} />

		<div className={className} id={`etfTwitterFeed-${clientId}`}>
			<Style attributes={attributes} clientId={clientId} />

			<div className={`etfTwitterFeed`}>
				{type ? <>
					{type == "timeline" && <div className="twitter_iframe">
						<Timeline attributes={attributes} />
					</div>}
					{type == "follow" && <FollowButton attributes={attributes} />}
					{type == "tweet" && <TweetButton attributes={attributes} />}
					{type == "tag" && <Hastag attributes={attributes} />}
					{['video', 'post'].includes(type) && <VideoPost attributes={attributes} />}
				</> :
					<Placeholder icon={twitterIcon('#03A9F4')} instructions={__("Choose a Feed type to get started.", "easy-twitter")} label={__("Choose a Feed Type", "easy-twitter")}>
						<BtnGroupPro value={type} onChange={val => setAttributes({ type: val })} options={types} proValues={['tweet', 'video', 'post', 'tag']} {...premiumProps} />
					</Placeholder>}
			</div>
		</div>
	</>;
};
export default Edit;


